import styled from "styled-components";

export const StyledFooter = styled.footer`
  padding: 16px;
  margin-top: 44px;
  border-top: 2px solid var(--color-gray-3);
  text-align: center;

  svg {
    color: var(--color-secondary);
    margin: 0px 10px;
    cursor: pointer;
  }

  p {
    margin-top: 12px;
  }
`;
